export default __webpack_public_path__ + "static/perf-e44091b3392c251d96b9d406bd65ffe2.png";